import React from "react";
import PropTypes from "prop-types";

// mui
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    cell: {
        display: "inline-block",
        maxWidth: "100%",
        width: "100%",
    },
    tooltip: {
        fontSize: "16px",
        fontWeight: 400,
        maxWidth: "500px",
        backgroundColor: "#616161",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "320px",
        },
    },
    blueColor: {
        color: "#6886EF",
    },
    defaultColor: {
        color: theme.palette.common.black,
    },
    grayColor: {
        color: "#6D6D6D",
    },
    smSize: {
        fontSize: "12px",
    },
    defaultSize: {
        fontSize: "14px",
    },
    defaultWeight: {
        fontWeight: 400,
    },
    mediumWeight: {
        fontWeight: 500,
    },
    ellipsis: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
    },
    cursorPointer: {
        cursor: "pointer",
    },
}));

export default function TableCell({ value, weight, color, size, ellipsis, tooltip, tooltipValue }) {
    const classes = useStyles();
    const useTooltip = tooltip && tooltipValue !== "-";

    let classNames = [
        classes.cell,
        classes[`${color || "default"}Color`],
        classes[`${size || "default"}Size`],
        classes[`${weight || "default"}Weight`],
    ];
    if (ellipsis) {
        classNames.push(ellipsis ? classes.ellipsis : "");
    }

    const CellElement = <span className={classNames.join(" ")}>{value}</span>;

    if (useTooltip) {
        return (
            <Tooltip title={tooltipValue} arrow classes={{ tooltip: classes.tooltip }}>
                {CellElement}
            </Tooltip>
        );
    }

    return CellElement;
}

TableCell.propTypes = {
    value: PropTypes.string.isRequired,
    color: PropTypes.string,
    size: PropTypes.string,
    weight: PropTypes.string,
    ellipsis: PropTypes.bool,
    tooltip: PropTypes.bool,
};
